import { render, staticRenderFns } from "./recentorder.vue?vue&type=template&id=6c15bc8f&"
import script from "./recentorder.vue?vue&type=script&lang=js&"
export * from "./recentorder.vue?vue&type=script&lang=js&"
import style0 from "./recentorder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports